import _ from 'lodash';

class Auth {
    _user = null;
    _token = null;

    saveUser(user) {
        user.props = _.reduce(
            user.defaultProps,
            (memo, p) => {
                try {
                    memo[p.key] = JSON.parse(p.value);
                } catch (e2) {
                    memo[p.key] = p.value;
                }
                return memo;
            },
            { lang: 'en' },
        );

        var serializedUser = JSON.stringify(user);
        localStorage.setItem('user', serializedUser);
        this._user = user;
    }

    getUser() {
        if (this._user) return this._user;

        var serializedUser = localStorage.getItem('user');
        if (!serializedUser) return null;
        this._user = JSON.parse(serializedUser);

        return this._user;
    }

    saveAccessToken(token) {
        localStorage.setItem('accessToken', token);
        this._token = token;
        return this._token;
    }

    getAccessToken() {
        return this._token || localStorage.getItem('accessToken');
    }

    logout(cb) {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        this._token = null;
        this._user = null;
    }

    loggedIn() {
        return Boolean(this.getAccessToken() && this.getUser());
    }

    hasAdminRights() {
        return this.loggedIn() && (this.getUser().roles || []).indexOf('admin') >= 0;
    }
}

const service = new Auth();
if (process.env.NODE_ENV !== 'prod') {
    window.auth = service;
}
export default new Auth();



/** WEBPACK FOOTER **
 ** ../src/dash/front/auth.js
 **/